import styled, { css } from "styled-components";

import { Theme } from "../../utils/theme";

interface ButtonProps {
  color?: keyof Theme["colors"];
  small?: boolean;

  onClick?: () => void;
}

export const Button = styled.button<ButtonProps>`
  ${(props) => css`
    font-family: "Gill Sans", "Helvetica", "Arial", sans-serif;
    font-style: normal;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 0.2rem;
    border: 2px solid ${props.color ? props.theme.colors[props.color] : "black"};
    color: ${props.color ? props.theme.colors[props.color] : "black"};
    padding: ${props.small ? "0.6rem 0.8rem" : "0.8rem 1.5rem"};
    font-weight: ${props.small && 600};
    font-size: ${props.small && "0.7rem"};
    transition: all ease-in-out 0.2s;
    cursor: pointer;
    &:hover,
    &:focus,
    &:active {
      background: ${props.color
        ? props.theme.colors[props.color]
        : "black"} !important;
      color: white;
    }
  `}
`;

interface LinkButtonProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  color?: keyof Theme["colors"];
  small?: boolean;
  href?: string;
}

export const LinkButton = styled.a<LinkButtonProps>`
  ${(props) => css`
    font-family: "Gill Sans", "Helvetica", "Arial", sans-serif;
    font-style: normal;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 0.2rem;
    border: 2px solid ${props.color ? props.theme.colors[props.color] : "black"};
    color: ${props.color ? props.theme.colors[props.color] : "black"};
    padding: ${props.small ? "0.6rem 0.8rem" : "0.8rem 1.5rem"};
    font-weight: ${props.small && 600};
    font-size: ${props.small && "0.7rem"};
    transition: all ease-in-out 0.2s;

    &:hover,
    &:focus,
    &:active {
      background: ${props.color
        ? props.theme.colors[props.color]
        : "black"} !important;
      color: white;
    }
  `}
`;
